// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.triangle {
  position: absolute;
  top: 9px;
  right: -20px;
  transform: rotate(45deg);
  width: 45px;
  height: 45px;
  background-color: white;
  z-index: -1;
  border-radius: 2px;
}

@media (min-width: 455px) {
  .triangle {
    top: 4px;
    right: -8px;
    width: 23px;
    height: 23px;
  }
}

@media (min-width: 1024px) {
  .triangle {
    top: 4px;
    right: -8px;
    width: 23px;
    height: 23px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/auth/pages/signup/signup.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".triangle {\n  position: absolute;\n  top: 9px;\n  right: -20px;\n  transform: rotate(45deg);\n  width: 45px;\n  height: 45px;\n  background-color: white;\n  z-index: -1;\n  border-radius: 2px;\n}\n\n@media (min-width: 455px) {\n  .triangle {\n    top: 4px;\n    right: -8px;\n    width: 23px;\n    height: 23px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .triangle {\n    top: 4px;\n    right: -8px;\n    width: 23px;\n    height: 23px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
